/* eslint-disable unicorn/filename-case -- TODO rename later */
import { getUserManager, refreshAccessToken } from "@istari-frontend/auth";
import { Toaster } from "@istari-frontend/ui";
import { SidebarProvider } from "@istari-frontend/ui";
import { ThemeProvider } from "next-themes";
import { useEffect } from "react";
import { AuthProvider, useAuth } from "react-oidc-context";
import { Outlet } from "react-router";

import "./App.css";
import { RemotesOperationsProvider } from "./contexts/remotes-operations.provider";
import { useFontSize } from "./hooks/use-font-size";
import AuthErrorBoundary from "./pages/Authentication/AuthErrorBoundary";

function App() {
  useFontSize();

  return (
    <AuthProvider userManager={getUserManager()}>
      <ProactiveTokenRefresh />
      <AuthErrorBoundary>
        <ThemeProvider attribute="class" defaultTheme="light" enableSystem storageKey="istari-theme-preference">
          <SidebarProvider defaultOpen={true}>
            <RemotesOperationsProvider>
              <Outlet />
            </RemotesOperationsProvider>
            <Toaster />
          </SidebarProvider>
        </ThemeProvider>
      </AuthErrorBoundary>
    </AuthProvider>
  );
}

export default App;

/**
 * Renews the access token shortly before expiry. Replaces the UserManager's
 * automaticSilentRenew, which renews per tab and so races other tabs over
 * single-use rotating refresh tokens.
 */
function ProactiveTokenRefresh() {
  const auth = useAuth();

  useEffect(() => auth.events.addAccessTokenExpiring(() => void refreshAccessToken()), [auth.events]);

  return null;
}
